module.exports = __webpack_public_path__ + "img/icon-32-ic-plug-inactive.e34d9393.svg";